import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  capitalize
} from '@mui/material';

export default function RedirectStore({ open, onClose, url, storeName }) {
  const handleCloseModal = () => {
    onClose(false);
  };

  const openURL = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="sm"  sx={{
      backdropFilter: 'blur(4px)',
      background: 'rgba(239, 234, 228, 0.72)',
      '& .MuiPaper-root': {
        borderRadius: '16px',
        border: '1px solid var(--Black, #000)',
        background: 'var(--White, #FFF)',
      },
    }}>
      <Container sx={{ padding: '16px' }}>
        <DialogTitle
          sx={{
            textAlign: 'center',
            fontSize: {xs: '24px', md:'30px'},
            fontWeight: '400',
            p: 0,
            mb: '8px',
          }}>{`You’re headed to ${capitalize(storeName)}`}</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: {xs:'16px', md:'20px'},
              fontWeight: '400',
            }}>
            Return to this registry and click "I've purchased this" if you buy
            the item.
          </Typography>
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Button
              onClick={() => openURL(url)}
              fullWidth
              sx={{
                borderRadius: '54px',
                border: '1px solid var(--Black, #000)',
                background: 'var(--Highlighter, #D6FE51)',
                '&:hover': {
                  background: 'var(--Highlighter, #D6FE51)',
                },
                my: {xs:'15px',md: '20px'},
                textTransform: 'none',
              }}>
              <Typography
                sx={{
                  fontSize: ' 16px',
                  fontWeight: '700',
                  color: 'var(--Black, #000)',
                }}>
                Got It
              </Typography>
            </Button>
            <Button
              onClick={handleCloseModal}
              fullWidth
              sx={{
                borderRadius: '54px',
                border: '1px solid var(--Black, #000)',
                background: '#FFF',
                textTransform: 'none',
              }}>
              <Typography
                sx={{
                  fontSize: ' 16px',
                  fontWeight: '700',
                  color: 'var(--Black, #000)',
                }}>
                Go Back
              </Typography>{' '}
            </Button>
          </Grid>
        </DialogContent>
      </Container>
    </Dialog>
  );
}
